import classNames from "classnames";
import { type BaseProductElementProps } from "~/feature/Product/types";
import { type LinkProps } from "~/common/components/Link";
import { forwardRef } from "react";
import { PreferredIndicator } from "~/feature/Product/elements/PreferredIndicator";
import { Designation } from "~/feature/Product/elements/Designation";

import classes from "./FullDesignation.module.less";

interface Props extends BaseProductElementProps {
  component?: keyof JSX.IntrinsicElements;
  designationComponent?: keyof JSX.IntrinsicElements;
  clickable?: boolean;
  linkProps?: LinkProps;
  truncate?: boolean;
}

export const FullDesignation = forwardRef<HTMLElement, Props>((props, ref) => {
  const { component: rootComponent, designationComponent, ...rest } = props;
  const Cmp = rootComponent ?? "div";

  if (props.truncate) {
    rest.className = classNames(rest.className, classes.truncate);
  }

  return (
    // @ts-ignore
    <Cmp className={classNames(props.className, classes.root, props.truncate && classes.truncate)} ref={ref}>
      <PreferredIndicator product={rest.product} />
      <Designation as={designationComponent} {...rest} />
    </Cmp>
  );
});
